import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const getTaskTimelineCardErrorMsg = _ref => {
  let commonProps = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
    message: "timeline.timelineCardError.engagement.TASK.error_jsx"
  }, commonProps));
};